// extracted by mini-css-extract-plugin
export default {"tableActionBtn":"LicensesSubscriptionStatus_tableActionBtn__U4sJR"};